import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getGaMeasurementId } from '../utils/initGoogleAnalytics'

export function useGAPageView() {
  const location = useLocation()
  const measurementId = getGaMeasurementId()

  useEffect(() => {
    if (!measurementId || typeof window === 'undefined' || !window.gtag) return

    window.gtag('config', measurementId, {
      page_path: location.pathname + location.search,
    })
  }, [location, measurementId])
}
